import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-[#6E6259]">
        <li>
          <Link
            to="/"
            data-testid="breadcrumb-beranda"
            className="hover:text-[#C84B27] transition-colors underline-offset-4 hover:underline"
          >
            Beranda
          </Link>
        </li>
        {items.map((it, i) => (
          <li key={it.path} className="flex items-center gap-1.5">
            <span aria-hidden="true" className="text-[#E2D3BE]">
              ›
            </span>
            {i === items.length - 1 ? (
              <span aria-current="page" className="text-[#2B1B12] font-medium">
                {it.name}
              </span>
            ) : (
              <Link to={it.path} className="hover:text-[#C84B27] transition-colors">
                {it.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
